import React from 'react';

const SuperHard = () => {
    return (
        <section className="">
            <div className="bg-gray-100/10">
                <img src={`${process.env.PUBLIC_URL}/images/super_hard.png`} className="flex justify-center w-full relative" alt=""></img>
                <div className="container mx-auto px-8 md:px-12 lg:px-20">
                    <div className="container mx-auto px-4">
                        <h1 className="text-3xl font-bold text-center text-gray-800 my-6">超ハードコース</h1>
                        <div className="mx-auto py-5 text-center bg-white/50 rounded-lg relative font-bold text-red-500 mb-8">
                            <p className="text-center text-4xl md:text-5xl">178,000
                                <div className="inline absolute">
                                    <span className="text-xl">&ensp;円&nbsp;</span><span className="text-base">税込</span>
                                </div>
                            </p>
                        </div>
                        <p className="text-gray-600 text-lg pb-10 text-center">
                            本当に超ハードです。この１ヵ月の合宿を乗り越えれば、あなたには新しい視野が拓けていること間違いなし。<br/>
                            AIを最大限活用し、バックエンドとフロントエンドの開発を経験することでその身に全体像を焼き付けます。<br/>
                            AI特化コースの内容も含んでいるため気合を入れてとりかかりましょう<br />
                            １ヵ月…長いようで短い期間、踏ん張れる者だけが受けることを許された試練（コース）です！

                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SuperHard;
